module.exports = __webpack_public_path__ + "static/media/animal-welfare-standards.af07fdb6.jpg";